import en from './en/index';
import ud from './ud/index';

export const messages = {
  en,
  ud,
};
